var _defs, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorHeader362Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 362,
    height: 760,
    viewBox: "0 0 362 760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;opacity:0.24;mix-blend-mode:overlay;}.b,.c{isolation:isolate;}.c{fill:none;stroke:#fff;stroke-width:2px;opacity:0.478;mix-blend-mode:soft-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080a2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 362,
    height: 760
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.955 108.633)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.182,
    cy: 4.202,
    rx: 3.182,
    ry: 4.202,
    transform: "translate(183.068 31.281)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.414,
    cy: 1.868,
    rx: 1.414,
    ry: 1.868,
    transform: "translate(0 36)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.414,
    cy: 1.868,
    rx: 1.414,
    ry: 1.868,
    transform: "translate(237.563 28.947)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.884,
    cy: 1.167,
    rx: 0.884,
    ry: 1.167,
    transform: "translate(122.316 26.338)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3.182,
    cy: 4.202,
    rx: 3.182,
    ry: 4.202,
    transform: "translate(100.068 583.281)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.414,
    cy: 1.868,
    rx: 1.414,
    ry: 1.868,
    transform: "translate(-21 637)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.414,
    cy: 1.868,
    rx: 1.414,
    ry: 1.868,
    transform: "translate(216.563 629.947)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.884,
    cy: 1.167,
    rx: 0.884,
    ry: 1.167,
    transform: "translate(101.316 627.338)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.168 112.045)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.666,0,7.93.636a1.012,1.012,0,0,1,.79.978l.634,9.144c.035.505-.262.886-.663.851l-7.264-.634A1.012,1.012,0,0,1,.637,10L0,.853C-.032.348.265-.033.666,0Z",
    transform: "translate(158.575 31) rotate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.036.257,4.286,0c.4-.031.7.355.666.862L4.7,5a.993.993,0,0,1-.779.975l-3.25.255c-.4.031-.7-.355-.666-.862L.257,1.232A.993.993,0,0,1,1.036.257Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 40.413)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.168 674.144)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.666,0,7.93.636a1.012,1.012,0,0,1,.79.978l.634,9.144c.035.505-.262.886-.663.851l-7.264-.634A1.012,1.012,0,0,1,.637,10L0,.853C-.032.348.265-.033.666,0Z",
    transform: "translate(130.575 -11) rotate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.036.257,4.286,0c.4-.031.7.355.666.862L4.7,5a.993.993,0,0,1-.779.975l-3.25.255c-.4.031-.7-.355-.666-.862L.257,1.232A.993.993,0,0,1,1.036.257Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -54, 8.413)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorHeader362Px);
export default __webpack_public_path__ + "static/media/errorHeader_362px.cb7438647f2d2ea8bd9094a7a2195968.svg";
export { ForwardRef as ReactComponent };